import storageKeys from '../configuration/storageKeys'

export const getShipsData = () =>
  JSON.parse(sessionStorage.getItem(storageKeys.ships))
